import { sendMetadataGetRequestAsync } from './MetadataApi';
import { IPromiseCache, cachedWrapper } from '@utilities/MemoryCachingHelpers';
import { Option, OptionSetDefinition } from '@src/app/interfaces/entitydefinition';
import { IODataResponse } from '@src/app/interfaces/general';

export class GlobalOptionSetDefinition {
    private static _globalOptionSetDefinition: IPromiseCache<IODataResponse<GlobalOptionSet>> = {};

    static async getGlobalAsync(optionsetName: string): Promise<GlobalOptionSet> {
        const optionSets = await this._getAllGlobalAsync();
        return optionSets.value.find(x => x.Name === optionsetName) || null;
    }

    private static async _getAllGlobalAsync(): Promise<IODataResponse<GlobalOptionSet>> {
        return cachedWrapper("GLOBAL", async () => {
            const response = await sendMetadataGetRequestAsync(`v1.0/talxis_RetrieveAllOptionSets`);
            if (!response.ok) {
                throw new Error(`Failed to fetch global option sets!`);
            }

            return response.json();
        }, this._globalOptionSetDefinition);
    }
}

interface GlobalOptionSet extends OptionSetDefinition {
    Name: string;
    OptionSetType: string;
    Options: Option[];
}